import { formatImageUrl } from '../media_util.js';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './image.module.scss';
import { useIntersection } from '../../hooks/useIntersection';


function LazyImage({
    className,
    hrefUrl,
    imageUrl,
    notLazy,
    post,
    shouldRender,
    title,
    toggleModal,
    trackPostClick,
    width,
}) {
    const hasMultilink = !!post.multilink;
    const {isIntersecting, elRef} = useIntersection({
        once: true,
        rootMargin: '300px',
        threshold: 0,
    });
    const imgSrcOne = formatImageUrl(imageUrl, width);
    const imageEl = (isIntersecting || notLazy) ?
        <img
            src={imgSrcOne}
            srcSet={`${imgSrcOne} 1x, ${formatImageUrl(imageUrl, 2 * width)} 2x`}
            alt={title}
            className={classNames(hasMultilink && styles.imageFillModal, styles.imageFill)}
            onError={() => {shouldRender(false);}}
        /> : null;

    return (<>
        <div className={styles.backgroundImage}
            style={{'backgroundImage': `url(${imgSrcOne})`}}
        />
        {hasMultilink ? (
            <a
                ref={elRef}
                onClick={() => {
                    trackPostClick();
                    toggleModal(post, imageEl);
                }}
                className={className}
            >
                {imageEl}
            </a>
        ) : (
            <a ref={elRef} href={hrefUrl} onClick={trackPostClick} className={className}>
                {imageEl}
            </a>
        )}
    </>);
}

LazyImage.propTypes = {
    title: PropTypes.string.isRequired,
    hrefUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    className: PropTypes.string,
    shouldRender: PropTypes.func,
    toggleModal: PropTypes.func,
    notLazy: PropTypes.bool,
};

export default LazyImage;
